import { AppError } from '~/shared/error/AppError';

export class AccessAppUnavailableError extends AppError {
  constructor() {
    super('error.ACCESS_APP_UNAVAILABLE');
  }
}
